<div *transloco="let t" class="organization-verification-modal">
  <div class="organization-verification-modal__header">
    <h2 class="organization-verification-modal__title" id="organization-verification-modal-title">
      {{ t('Organization verification') }}
    </h2>
    <button
      type="button"
      class="organization-verification-modal__close"
      [attr.aria-label]="t('Close')"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="organization-verification-modal__body">
    <p class="organization-verification-modal__text" id="organization-verification-modal-desc">
      {{ t('organization-verification-modal-description') }}
    </p>
  </div>

  <div class="organization-verification-modal__footer">
    <bi-button variant="filled" [height]="40" [fontSizeText]="14" (clicked)="close()">
      {{ t('OK') }}
    </bi-button>
  </div>
</div>
